'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from 'contexts/InAppProvider';
import { PromotionPage } from 'app/(appHeader)/promotions/2024-santa-ritto/PromotionPage';
import { configure } from 'utils/configure';

const metadata = {
  title: '산타 리토의 선물 대작전! | 디리토',
  openGraph: {
    title: '산타 리토의 선물 대작전!',
    description: '다함께 전구를 모으면 전원 최대 1,500P!',
    url: 'https://www.diritto.co.kr/promotions/2024-santa-ritto',
    siteName: '디리토',
    locale: 'ko_KR',
    type: 'website',
    images: [
      {
        url: `${configure.staticPrefix}/images/og/santa-ritto.png?v=1`,
        width: 400,
        height: 209,
      },
    ],
  },
};

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');
  return (
    <>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.openGraph.description} />
      <meta property="og:title" content={metadata.openGraph.title} key="title" />
      <meta property="og:description" content={metadata.openGraph.description} key="description" />
      <meta property="og:url" content={metadata.openGraph.url} key="url" />
      <meta property="og:site_name" content={metadata.openGraph.siteName} key="site_name" />
      <meta property="og:locale" content={metadata.openGraph.locale} key="locale" />
      <meta property="og:type" content={metadata.openGraph.type} key="type" />
      <meta property="og:image" content={metadata.openGraph.images[0].url} key="image" />
      <meta property="og:image:height" content={String(metadata.openGraph.images[0].height)} key="image:height" />
      <meta property="og:image:width" content={String(metadata.openGraph.images[0].width)} key="image:width" />
      <PromotionPage isApp={isApp} />
    </>
  );
}
